/** @file variant.add: declares a variant flag that facet entries may require. */
import { ERROR_CODES } from '@zilo/pose3d-format/errors/codes';
import { throwError } from '@zilo/pose3d-std/errors/throwError';
import type { CommandDef } from '../apply/commandDef';
import { readInput } from '../validate/readInput';

/** `variant.add { variant }` → `{}`; inverse: `variant.remove`. */
export const variantAddCommand: CommandDef<'variant.add'> = {
  name: 'variant.add',
  /** Checks the raw input (VALIDATION under the input path). */
  validate: (input, path) => ({ variant: readInput(input, path, ['variant']).name('variant') }),
  /** Applies the command to the draft and returns its result and inverse. */
  apply: (draft, input) => {
    if (draft.puppet.variants.includes(input.variant)) {
      throwError(ERROR_CODES.VALIDATION, { variant: input.variant }, { path: '/input/variant', hint: 'the variant exists' });
    }
    draft.puppet.variants.push(input.variant);
    return { result: {}, warnings: [], inverse: [{ name: 'variant.remove', input: { variant: input.variant } }] };
  },
};
